import { Typography } from '@mui/material';

export const TransformationHeading = ({ title, disabled = false }) => (
  <Typography
    variant="subtitle1"
    sx={{ mb: 2, fontWeight: 500, color: disabled ? 'text.disabled' : 'text.primary', opacity: disabled ? 0.6 : 1 }}
  >
    {title}
  </Typography>
);
